import { render } from "./FormOc.vue?vue&type=template&id=651fe202"
import script from "./FormOc.vue?vue&type=script&lang=js"
export * from "./FormOc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__